/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnqueueBenchmarkAllRunsResult } from '../../models/enqueue-benchmark-all-runs-result';
import { EnqueueBenchmarkRunRequest } from '../../models/enqueue-benchmark-run-request';

export interface ApiAdminBenchmarksBenchmarkIdRunsPost$Params {
  benchmarkId: string;
      body?: EnqueueBenchmarkRunRequest
}

export function apiAdminBenchmarksBenchmarkIdRunsPost(http: HttpClient, rootUrl: string, params: ApiAdminBenchmarksBenchmarkIdRunsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<EnqueueBenchmarkAllRunsResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminBenchmarksBenchmarkIdRunsPost.PATH, 'post');
  if (params) {
    rb.path('benchmarkId', params.benchmarkId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnqueueBenchmarkAllRunsResult>;
    })
  );
}

apiAdminBenchmarksBenchmarkIdRunsPost.PATH = '/api/Admin/benchmarks/{benchmarkId}/runs';
